export default __webpack_public_path__ + "static/media/51.416a73e5.jpg";